// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { type AuthUser } from '@/types';
import { useLocalStorage } from '@vueuse/core';

export default defineNuxtRouteMiddleware((middleware) => {
  const { isAuthenticated } = useSanctumAuth();
  const user: Ref<AuthUser | null> = useSanctumUser();

  if (!middleware.query.token) {
    if (!isAuthenticated.value) {
      useLocalStorage('redirect_to', middleware.path);
      return navigateTo('/vdp/login');
    }

    if (user.value && user.value.roles) {
      const roles = user.value.roles;

      if (roles.includes('researcher') && !roles.includes('vendor')) {
        return abortNavigation();
      }
    } else {
      return navigateTo('vdp/login');
    }
  }
});
